import InputWrapper from '../input/wrapper';

export default InputWrapper;
